import React from 'react';

import Button from 'components/Button';
import Modal from 'common/components/modals/Modal';
import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import CommitmentText from 'components/CommitmentText';
import { TranslatedMessage } from 'common/components/Intl';
import SubscriptionCommitModalFooter from 'components/SubscriptionCommitModalFooter';

export default class SubscriptionCommitButton extends React.Component {
  state = {
    isOpen: false,
  };

  static propTypes = {
    isSubscribed: propTypes.bool.isRequired,
    offering: accountPropTypes.VariantOffering.isRequired,
    showRecommitCTAs: propTypes.bool.isRequired,
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  renderModal = () => {
    const { isOpen } = this.state;
    const { offering } = this.props;
    return (
      <Modal
        className="SubscriptionCommitButton__modal"
        bodyClassName="Modal__body--large container"
        isOpen={isOpen}
        onRequestClose={this.closeModal}
      >
        <CommitmentText {...this.props} />
        <SubscriptionCommitModalFooter
          onClose={this.closeModal}
          offering={offering}
          acceptTranslationId={this.acceptTranslationId}
          dismissTranslationId="cart.subscription_commit_button.decline"
        />
      </Modal>
    );
  };

  get acceptTranslationId() {
    if (this.props.isSubscribed)
      return this.props.showRecommitCTAs
        ? 'cart.subscription_commit_button.add_to_cart'
        : 'cart.subscription_commit_button.recommit_disabled';
    return 'cart.subscription_commit_button.get_it_with_autoship';
  }

  render() {
    return (
      <div>
        <Button
          onClick={this.openModal}
          disabled={this.props.isSubscribed && !this.props.showRecommitCTAs}
          className="SubscriptionCommitButton button--full-width button--vivid"
        >
          <TranslatedMessage id={this.acceptTranslationId} />
        </Button>
        {this.renderModal()}
      </div>
    );
  }
}
